import { mainSiteUrl } from '@/mocks/categories';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[600px] md:h-[700px] flex items-end overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Stylish%20editorial%20product%20photography%20with%20designer%20sneakers%20leather%20bags%20gold%20accessories%20and%20elegant%20clothing%20pieces%20arranged%20on%20light%20marble%20surface%20with%20soft%20morning%20sunlight%20casting%20gentle%20shadows%20luxury%20aesthetic%20minimal%20composition%20warm%20beige%20and%20cream%20tones&width=1600&height=900&seq=hero-main-2026-v2&orientation=landscape"
        alt="AllChinaBuy Spreadsheet - Best trusted product finds and seller links"
        title="AllChinaBuy Spreadsheet product photography"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/25 to-black/35"></div>

      <div className="relative z-10 w-full px-6 md:px-10 pb-16 md:pb-20">
        <div className="max-w-3xl">
          <span className="inline-block px-4 py-1.5 border border-white/40 rounded-full text-white/90 text-xs md:text-sm font-medium mb-5 whitespace-nowrap">
            Free AllChinaBuy Spreadsheet
          </span>

          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl text-white font-light leading-tight mb-5">
            Best AllChinaBuy<br />Spreadsheet 2026
          </h1>

          <p className="text-white/80 text-base md:text-lg max-w-xl mb-8 leading-relaxed">
            Explore thousands of verified products, trusted sellers, QC photos, clothing, shoes and accessories updated daily.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="bg-primary-500 hover:bg-primary-600 text-white px-8 py-3.5 rounded-full text-sm font-semibold whitespace-nowrap transition-all cursor-pointer text-center flex items-center justify-center gap-2"
            >
              AllChinaBuy Sheet
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-sm"></i>
              </div>
            </a>
            <a
              href="#categories"
              className="border border-white/50 hover:border-white text-white px-8 py-3.5 rounded-full text-sm font-medium whitespace-nowrap transition-all cursor-pointer text-center"
            >
              Browse Spreadsheet
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}